import React from 'react'

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.linkedin.com/in/mr-guru-k/" className="home__social-icon" target="_blank"> <i class="uil uil-linkedin-alt"></i> </a>
            <a href="https://github.com/Guru1926" className="home__social-icon" target="_blank"> <i className='uil uil-github-alt'></i> </a>
            <a href="https://www.instagram.com/mr_guru_k_/" className="home__social-icon" target="_blank"> <i className='uil uil-instagram'></i></a>
        </div>
    )
}

export default Social